var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProduction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.0336 7.9126H13.825C13.6318 7.9126 13.4385 8.06723 13.4385 8.29917V18.6979C13.4385 18.8912 13.5931 19.0845 13.825 19.0845H17.0336C17.2269 19.0845 17.4201 18.9298 17.4201 18.6979V8.29917C17.4201 8.10588 17.2655 7.9126 17.0336 7.9126Z",
    fill: "#ACBED2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.4281 10.4253H8.21958C8.02629 10.4253 7.83301 10.5799 7.83301 10.8119V18.6979C7.83301 18.8912 7.98764 19.0845 8.21958 19.0845H11.4281C11.6214 19.0845 11.8147 18.9298 11.8147 18.6979V10.8119C11.8147 10.5799 11.6214 10.4253 11.4281 10.4253Z",
    fill: "#ACBED2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.78496 12.5898H2.61509C2.4218 12.5898 2.22852 12.7445 2.22852 12.9764V18.6977C2.22852 18.8909 2.38314 19.0842 2.61509 19.0842H5.82362C6.0169 19.0842 6.21019 18.9296 6.21019 18.6977V12.9764C6.17153 12.7445 6.0169 12.5898 5.78496 12.5898Z",
    fill: "#ACBED2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.4201 0.915527H14.6368C14.3276 0.915527 14.0956 1.14747 14.0956 1.45673C14.0956 1.76598 14.3276 1.99792 14.6368 1.99792H15.8739C15.9512 1.99792 16.0285 2.11389 15.9512 2.19121L11.3123 6.40482C11.1964 6.48214 11.0417 6.48214 10.9644 6.40482L7.71724 3.62152C7.52395 3.42823 7.21469 3.46689 7.02141 3.62152L0.179119 10.1159C-0.0528235 10.3092 -0.0528235 10.6571 0.140462 10.8504C0.256433 10.9664 0.372404 11.005 0.527032 11.005C0.643003 11.005 0.797631 10.9664 0.874945 10.8504L7.21469 4.85854C7.33067 4.78123 7.48529 4.74257 7.56261 4.85854L10.8098 7.64185C11.0031 7.83513 11.3123 7.79647 11.5056 7.64185L16.7243 2.88703C16.8016 2.80972 16.9176 2.88703 16.9176 2.96435V4.20137C16.9176 4.51063 17.1495 4.74257 17.4588 4.74257C17.7681 4.74257 18 4.51063 18 4.20137V1.45673C17.9613 1.14747 17.7294 0.915527 17.4201 0.915527Z",
    fill: "#ACBED2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduction);
export default __webpack_public_path__ + "static/media/Production.9542269177af040854ea130972c5933f.svg";
export { ForwardRef as ReactComponent };